import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ChevronLeftIcon, ChevronRightIcon } from '../../assets';
import { theme } from '../../theme';
import { rgba } from 'polished';

const Container = styled.section`
  width: 100%;
  max-width: 1272px;
  margin: 0 auto;

  .slick-slide {
    overflow: hidden;
  }

  .slick-next,
  .slick-prev {
    height: ${theme.spacings[4].rem};
    fill: white;
    background: ${theme.colors.neutrals.transparentGrays[2]};
    border-radius: ${theme.borderRadius.default};
    padding: ${theme.spacings[5].rem} ${theme.spacings[1].rem};
    z-index: 1;
    &:hover {
      background: ${rgba(theme.colors.neutrals.transparentGrays[2], 0.9)};
    }
  }

  .slick-next {
    right: 0;
  }

  .slick-prev {
    left: 0;
  }

  .slick-dots {
    bottom: ${theme.spacings[3].rem};
  }

  .slick-dots li button:before {
    content: '';
    background: #fff;
    width: 8px;
    height: 8px;
    font-size: 8px;
    line-height: 1.2;
    opacity: 1;
    border: ${theme.borderRadius.default} solid #fff;
    border-radius: 50%;
  }

  .slick-dots li.slick-active button:before {
    background: red;
    border: ${theme.borderRadius.default} solid #fff;
    border-radius: 50%;
  }
`;

export const Carousel: React.FC<PropsWithChildren> = ({
  children,
}): JSX.Element => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <ChevronRightIcon />,
    prevArrow: <ChevronLeftIcon />,
  };
  return (
    <>
      <Container>
        <Slider {...settings}>{children}</Slider>
      </Container>
    </>
  );
};
